import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const HeaderContainer = styled.div`
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    @media screen and (max-width:800px){
        
        padding: 10px;
        margin-bottom: 140px;
        flex-direction: column;
      
    }
`;
export const LogoContainer = styled(Link)`
    height: 100%;

    padding: 25px;
    @media screen and (max-width:800px){
        width: 100%;
        padding: 5px;
        justify-self: center;
        padding-left : 35vw;
        margin-bottom:100px;
    }
`;
export const OptionsContainer = styled.div`
    width: 90%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    margin-top: 50px;
    @media screen and (max-width:800px){
        width: 100%;
        padding: 0px;
        margin:10px 0;
        justify-content: center;
        margin-bottom:10px;
        border-bottom: 1px solid black;
    }
`;
export const OptionLink = styled(Link)`
padding: 10px 15px;
cursor: pointer;
word-wrap: none;
`